import { loadStripe, type Stripe } from "@stripe/stripe-js";

const cache = new Map<string, Promise<Stripe | null>>();

export function getStripePromise(publishableKey: string): Promise<Stripe | null> {
  let promise = cache.get(publishableKey);
  if (!promise) {
    promise = loadStripe(publishableKey);
    cache.set(publishableKey, promise);
  }
  return promise;
}
